import {
  PARAGRAPH_TITLE_ERROR,
  PARAGRAPH_CONTENT_ERROR,
  PARAGRAPH_LESSON_ERROR,
  PARAGRAPH_RANK_ERROR,
  SHOW_ERROR,
} from "constants/messages/error";

// eslint-disable-next-line import/prefer-default-export
export const errorMessage = {
  rank: PARAGRAPH_RANK_ERROR,
  title: PARAGRAPH_TITLE_ERROR,
  contents: PARAGRAPH_CONTENT_ERROR,
  lesson: PARAGRAPH_LESSON_ERROR,
  showed: SHOW_ERROR,
};
